export default "__VITE_ASSET__oIKxkB2q__"